export default function DecorativeEllipse({
  className = "",
  size = 300,
  opacity = 0.15,
  blur = 80,
}: {
  className?: string;
  size?: number;
  opacity?: number;
  blur?: number;
}) {
  return (
    <div
      className={`absolute pointer-events-none ${className}`}
      style={{
        width: size,
        height: size,
        opacity,
        filter: `blur(${blur}px)`,
        backgroundImage:
          "url(https://storage.readdy-site.link/project_files/47bfa220-4dc0-474b-be5e-43bab3838ebf/d0138adb-94cc-4428-a184-3a4d81bd3102_Ellipse-7.png?v=4657e31e274c090970a444122d587150)",
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
      }}
    />
  );
}